import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {CountryModel} from '../country.model';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CountryConverter extends HttpModelConverter<CountryModel> {

    protected createInstance(): CountryModel {
        return new CountryModel();
    }

    protected enrichObject(result: CountryModel, src: CountryModel) {
    }


}